import React, { useMemo, useCallback } from 'react';
import './styles.scss';

const MAX_VISIBLE_PAGES = 5;

const Pagination = ({ pagingModel, handlePagination, reportTime }) => {
    const { TotalCount = 0, Rows = 10, Page = 1 } = pagingModel || {};

    const { pages, totalPages, currentPage } = useMemo(() => {
        const totalPages = Math.ceil(TotalCount / Rows) || 0;
        const currentPage = Page;
        const halfWindow = Math.floor(MAX_VISIBLE_PAGES / 2);

        let start = Math.max(1, currentPage - halfWindow);
        let end = Math.min(totalPages, start + MAX_VISIBLE_PAGES - 1);

        if (end - start + 1 < MAX_VISIBLE_PAGES) {
            start = Math.max(1, end - MAX_VISIBLE_PAGES + 1);
        }

        const pages = [];
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        return { pages, totalPages, currentPage };
    }, [TotalCount, Rows, Page]);

    const goTo = useCallback((page) => {
        if (page >= 1 && page <= totalPages && page !== currentPage) {
            handlePagination(page);
        }
    }, [totalPages, currentPage, handlePagination]);

    const isFirstPage = currentPage <= 1;
    const isLastPage = currentPage >= totalPages;

    if (totalPages <= 1) {
        return reportTime ? <div><div className="time-container">{reportTime}</div></div> : null;
    }

    return (
        <div>
            <div className="pagination">
                <a
                    href="javascript:void(0)"
                    className={`first${isFirstPage ? ' disable' : ''}`}
                    title="First"
                    onClick={() => goTo(1)}
                >First</a>
                <a
                    href="javascript:void(0)"
                    className={`prev${isFirstPage ? ' disable' : ''}`}
                    title="Previous"
                    onClick={() => goTo(currentPage - 1)}
                >Previous</a>
                {pages.map((pageNum) => (
                    <a
                        key={pageNum}
                        href="javascript:void(0)"
                        className={currentPage === pageNum ? 'active' : ''}
                        onClick={() => goTo(pageNum)}
                    >
                        {pageNum}
                    </a>
                ))}
                <a
                    href="javascript:void(0)"
                    className={`next${isLastPage ? ' disable' : ''}`}
                    title="Next"
                    onClick={() => goTo(currentPage + 1)}
                >Next</a>
                <a
                    href="javascript:void(0)"
                    className={`last${isLastPage ? ' disable' : ''}`}
                    title="Last"
                    onClick={() => goTo(totalPages)}
                >Last</a>
            </div>
            {reportTime && (
                <div className="time-container">
                    {reportTime}
                </div>
            )}
        </div>
    );
};

export default Pagination;
